<template>
  <div class="bg-green-900 w-screen flex-row md:hidden">
    <div class="dropdown">
      <h2 class="text-left font-semibold uppercase">Peristock</h2>
      <button class="dropbtn pr-4 pl-4 text-xl" @click="showMenu">
        <i class="fas fa-bars"></i>
      </button>
    </div>
    <div
      :style="{ display: menuIsShowed ? 'block' : 'none' }"
      class="dropdown-content"
    >
      <a href="">Termes du service</a>
      <a href="mailto:peristock.dev@gmail.com" class="opacity-70">Contact</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuIsShowed: false,
    };
  },
  methods: {
    showMenu() {
      this.menuIsShowed = !this.menuIsShowed;
    },
  },
};
</script>

<style lang="postcss" scoped>
.dropdown {
  @apply flex justify-between text-right border-none p-2 bg-green-900 m-2 outline-none text-lg text-white;
}

.dropdown-content {
  @apply text-right text-white bg-green-900 drop-shadow-lg pr-4;
}
.dropdown-content a {
  @apply py-2 block whitespace-nowrap float-none text-base text-white font-semibold pt-2;
}

.dropdown-content a:hover {
  @apply opacity-100;
}
</style>